import { render } from "./LoginInfo.vue?vue&type=template&id=596d4e6a"
import script from "./LoginInfo.vue?vue&type=script&lang=js"
export * from "./LoginInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__